import React, { useEffect, useState } from "react";
import Menu from "./Menu";
import MenuModal from "./MenuModal";

const Header = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [onActive, setOnActive] = useState(props.target);
  const menuItems = [
    { id: "home", name: "home", src: "#" },
    { id: "service", name: "service", src: "#service" },
    { id: "testimonial", name: "testimonial", src: "#testimonial" },
    { id: "about", name: "about", src: "#about" },
    { id: "contactus", name: "contact us", src: "#contactus" },
  ];
  const info = {
    email: "hyunki@illustudio.co.kr",
    tel: "(+82)000-0000-0000",
  };

  const activeHandler = (id) => {
    setOnActive(id);
  };

  const modalHandler = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const scrollHandler = (target) => {
    setOnActive(target);
  };
  useEffect(() => {
    window.addEventListener("scroll", () => {
      scrollHandler(props.target);
    });
    return () => {
      window.removeEventListener("scroll", () => setOnActive(props.target));
    };
  }, [props.target]);

  return (
    <div className="w-full bg-indigo-800 text-white p-4 backdrop-blur-sm  bg-opacity-80 fixed top-0 z-10">
      <div className="container max-w-[1280px] flex items-center justify-between">
        <figure className="w-[48px] overflow-hidden lg:w-[224px]">
          <img
            className="w-[224px] h-[56px] max-w-[224px]"
            src="/assets/logo.webp"
            alt=""
          />
        </figure>
        <div className="hidden lg:flex lg:gap-8 lg:items-center">
          <Menu
            navMenu={menuItems}
            info={info}
            onActive={onActive}
            activeHandler={activeHandler}
          />
        </div>
        <button className="block lg:hidden " onClick={modalHandler}>
          Menu
        </button>

        <MenuModal
          isOpen={isOpen}
          navMenu={menuItems}
          info={info}
          onActive={onActive}
          activeHandler={activeHandler}
          openHandler={modalHandler}
        />
      </div>
    </div>
  );
};

export default Header;
